export const isClient =
   typeof window !== 'undefined' && window.document ? true : false
